<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title">HOW TO MAKE COLLABORATION WORK</h1>
<div class="image"><img alt="image" src="images/0001.jpg"/></div>
<h1 class="subtitle">Powerful Ways to Build Consensus, Solve Problems, and Make Decisions</h1><br/><br/>
<h2 class="author">DAVID STRAUS</h2><br/><br/><br/><br/>
<div class="image"><img alt="image" src="images/0002.jpg"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?08820072